<template lang="pug">
header.k-header( :class='size' )
  slot
</template>

<script lang="js">

export default {
  name: 'HeaderBlock',
  mixins: [],
  components: {},
  props: {
    size: {
      type: String,
      default: 'lg'
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.k-header {
  &.xs2 {
    font-size: var(--s-2xs);
  }
  &.xs {
    font-size: var(--s-xs);
  }
  &.sm {
    font-size: var(--s-sm);
  }
  &.q3 {
    font-size: var(--s-3q);
  }
  &.base {
    font-size: var(--s-base);
  }
  &.lg {
    font-size: var(--s-lg);
  }
  &.lg2 {
    font-size: var(--s-2lg);
  }
  &.xl {
    font-size: var(--s-xl);
  }
  &.xl2 {
    font-size: var(--s-2xl);
  }
  &.xl3 {
    font-size: var(--s-3xl);
  }
  &.huge {
    font-size: var(--s-huge);
  }
  margin-bottom: var(--mb-header, var(--s-base));
  > .k-header {
    margin-bottom: 0;
  }
}
</style>
